<template>
  <Layout title="Buchen" h1="Buchen" :banner="$page.props.banner">
    <booking :nav="false">
      <div class="text-center">
        <h1 class="h3 text-primary">Vielen Dank für deine Buchung!</h1>

        <p class="mt-4">
          Eine <span class="fw-bold">Buchungsbestätigung</span> mit allen
          Details bekommst du per E-Mail.<br />
          Bei aufkommenden Fragen stehen wir dir gerne zur Verfügung:
          <a href="tel:+49443596000" class="text-dark text-decoration-none"
            >+49 4435 960 00</a
          >
        </p>

        <p class="my-3" v-if="bookingModel.travel_insurance">
          Durch das Setzen des Hakens auf der vorherigen Seite wird die
          Reiseversicherung <b>nicht</b> automatisch beauftragt! Wir bieten mit
          unserem Partner, der Hanse Merkur, zahlreiche Versicherungen rund um
          euren Urlaub.<br />
          Zur Online Buchung klicke
          <a
            href="https://secure.hmrv.de/rvw-ba/initBa.jsp?baid=333&adnr=3298593&locale=de_DE"
            class="text-decoration-none"
            target="_blank"
            rel="noopener noreferrer"
            >hier</a
          >.
        </p>

        <p>Wir freuen uns auf die Skireise mit dir!</p>
        <p class="fw-bold">Dein SCOL-Team</p>

        <Link
          :href="$route('home')"
          class="btn btn-primary rounded-pill text-decoration-none mt-4"
          >Zurück zur Startseite</Link
        >
      </div>
    </booking>
  </Layout>
</template>
<script>
import { Link } from "@inertiajs/inertia-vue3";
import Layout from "../Layouts/Booking";
import Booking from "./Booking";
import BookingFormModel from "../../Models/BookingFormModel";

export default {
  components: {
    Layout,
    Booking,
    Link,
  },
  props: {
    errors: Object,
    bookingForm: Object,
    bookingModel: Object,
  },
  mounted() {
    this.syncModel(true);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "purchase",
      ecommerce: {
        transaction_id: this.bookingModel.response.data.t_vorgang.data.nr,
        value: this.bookingModel.response.data.t_vorgang.data.endpreis,
        currency: "EUR",
        items: [
          {
            item_id: this.bookingModel.response.data.t_vorgang.data.nr,
            item_name: this.bookingModel.response.data.t_vorgang.data.reisebezeichnung,
          },
        ],
      },
    });
  },
  computed: {
    model() {
      return BookingFormModel.make(this.bookingForm).setSession(this.$session);
    },
  },
  methods: {
    syncModel(reload = false, callback) {
      return this.model
        .toStorage()
        .syncToServer()
        .then(() => {
          if (reload) {
            this.reloadOnly(callback);
          }
        });
    },
    reloadOnly(options) {
      options = {
        ...{
          data: { t: this.$session.tab_id },
        },
        ...options,
      };
      this.$inertia.reload(options);
    },
  },
};
</script>
